import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import FormSection from 'components/shared/FormSection';
import RecruitmentInfo from './RecruitmentInfo';
import JobDescription from './JobDescription';
import JobApplicationProfile from './JobApplicationProfile';
import JobRequirements from './JobRequirements';
import JobBenefits from './JobBenefits';
import FormStatus from 'components/shared/FormCommon/FormStatus';

function RecruitmentTab() {
  const { pathname } = useLocation();
  const disabled = useMemo(() => pathname.includes('/detail'), [pathname]);

  const detailForm = [
    {
      title: 'Thông tin tuyển dụng',
      component: RecruitmentInfo,
      fieldActive: [
        'recruitment_name',
        'business_id',
        'department_id',
        'position_id',
        'employment_type',
        'quantity',
        'salary',
        'posted_date',
        'expired_date',
      ],
    },
    {
      title: 'Mô tả công việc',
      component: JobDescription,
      fieldActive: ['job_description'],
    },
    {
      title: 'Yêu cầu công việc',
      component: JobRequirements,
      fieldActive: ['requirements'],
    },
    {
      title: 'Quyền lợi',
      component: JobBenefits,
      fieldActive: ['benefits'],
    },
    {
      title: 'Hồ sơ ứng tuyển',
      component: JobApplicationProfile,
      fieldActive: ['request_profile'],
    },
    {
      importd: 'form_status',
      title: 'Trạng thái',
      hiddenSystem: true,
      component: FormStatus,
    },
  ];

  return <FormSection loading={false} detailForm={detailForm} disabled={disabled} />;
}

export default RecruitmentTab;

// Build 2
